module.exports = __webpack_public_path__ + "img/likkedin.sh.dbec366e.svg";